import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

interface PromptsViewLayoutProps {
  header: ReactNode;
  filters: ReactNode;
  children: ReactNode;
}

export const PromptsViewLayout = ({ header, filters, children }: PromptsViewLayoutProps) => {
  return (
    <Stack
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: colors.white,
      }}
    >
      {header}
      {filters}
      {children}
    </Stack>
  );
};
